// ENGLISH

export default {
    values: {
        'Type to search': 'Type to search',
        REMOVE: 'REMOVE',
        Creating: 'Creating',
        Create: 'Create',
        Close: 'Close',
        Cancel: 'Cancel',
        'Confirm deletion': 'Confirm deletion',
        'No, I do not': 'No, I do not',
        of: 'of',
        items: 'items',
        Default: 'Default',
        Ascending: 'Ascending',
        Descending: 'Descending',
        All: 'All',
        Description: 'Description',
        Name: 'Name',
        Save: 'Save',
        Asset: 'Asset',
        ASSET: 'ASSET',
        Responsible: 'Responsible',
        'Live Event Id': 'Live Event Id',
        'Live Event ID': 'Live Event ID',
        Showing: 'Showing',

        /* ---------------------------------------------------------------------------------------------------------- */

        // FETCH ERROR
        'An error occurred on get operations.': 'An error occurred on get operations.',
        'An error occurred on create diagram.': 'An error occurred on create diagram.',
        'An error occurred on list bowties.': 'An error occurred on list bowties.',
        'An error occurred on get barrier status.': 'An error occurred on get barrier status.',
        'An error occurred on get bowtie.': 'An error occurred on get bowtie.',
        'Diagram saved successfully.': 'Diagram saved successfully.',
        'Error on save barrier.': 'Error on save barrier.',
        'Error on save bowtie.': 'Error on save bowtie.',
        'An error occurred on register supervisor': 'An error occurred on register supervisor',
        // END FETCH ERROR

        /* ---------------------------------------------------------------------------------------------------------- */

        // FETCH SUCCESSFULLY
        'Error on save diagram.': 'Error on save diagram.',
        'Barrier saved successfully.': 'Barrier saved successfully.',
        'Bowtie saved successfully.': 'Bowtie saved successfully.',
        // END FETCH SUCCESSFULLY

        /* ---------------------------------------------------------------------------------------------------------- */

        // BOWTIE GENERAL
        THREAT: 'THREAT',
        Threats: 'Threats',
        Threat: 'Threat',
        threat: 'threat',

        Barriers: 'Barriers',
        Bowties: 'Bowties',
        Diagrams: 'Diagrams',

        PREVENTION: 'PREVENTION',

        HAZARD: 'HAZARD',
        Hazard: 'Hazard',

        MITIGATION: 'MITIGATION',

        CONSEQUENCE: 'CONSEQUENCE',
        Consequences: 'Consequences',
        Consequence: 'Consequence',
        consequence: 'consequence',

        'Top Event': 'Top Event',
        'TOP EVENT': 'TOP EVENT',
        TOPEVENT: 'TOP EVENT',

        'Initial Freq.': 'Initial Freq.',
        'Final Freq.': 'Final Freq.',
        'Tolerable Freq.': 'Tolerable Freq.',
        'Threshold Freq.': 'Threshold Freq.',

        BARRIER: 'BARRIER',
        BARRIERS: 'BARRIERS',
        Barrier: 'Barrier',

        'Refresh Barriers': 'Refresh Barriers',

        'ESCALATION FACTOR': 'ESCALATION FACTOR',
        'Escalation Factor': 'Escalation Factor',
        'Escalation Factors': 'Escalation Factors',
        'Enabled degradation criteria:': 'Enabled degradation criteria:',

        Marine: 'Marine',
        Drilling: 'Drilling',
        Operation: 'Operation',
        Emergency: 'Emergency',
        marine: 'Marine',
        drilling: 'Drilling',
        operation: 'Operation',
        emergency: 'Emergency',

        'System ID': 'System ID',
        'Mandatory Barrier': 'Mandatory Barrier',
        'Hide frequency on threats and consequences': 'Hide frequency on threats and consequences',
        'Show frequency on threats and consequences': 'Show frequency on threats and consequences',
        // END BOWTIE GENERAL

        /* ---------------------------------------------------------------------------------------------------------- */

        // RISK MANAGEMENT EDITOR
        Active: 'Active',
        'All Operations': 'All Operations',
        'Select Resource': 'Select Resource',
        RESOURCE: 'RESOURCE',
        Resources: 'Resources',
        'Leave without saving': 'Leave without saving',
        'CONTROL BARRIER': 'CONTROL BARRIER',
        'Barrier Category': 'Barrier Category',
        'barrier categories':'barrier categories',
        Criticality: 'Criticality',
        'LIST OF ENTITIES': 'LIST OF ENTITIES',
        OPERATION: 'OPERATION',
        'Risk Management': 'Risk Management',
        'Risk Diagram': 'Risk Diagram',
        'This action cannot be undone.': 'This action cannot be undone.',
        'Features that read this list will be affected.': 'Features that read this list will be affected.',
        'in the field below before completing the action:': 'in the field below before completing the action:',
        'Bowtie Editor': 'Bowtie Editor',
        'YOU DO NOT HAVE PERMISSION TO ACCESS THE EDITOR.': 'YOU DO NOT HAVE PERMISSION TO ACCESS THE EDITOR.',
        'YOU DO NOT HAVE PERMISSION TO ACCESS THE BOWTIE SETTINGS.':
            'YOU DO NOT HAVE PERMISSION TO ACCESS THE BOWTIE SETTINGS.',
        'Are you sure you want to leave without saving your work?':
            'Are you sure you want to leave without saving your work?', // eslint-disable-line max-len, prettier/prettier

        /// RISK MANAGEMENT EDITOR - DIAGRAMS LIST
        'New Diagram': 'New Diagram',
        'Create new diagram': 'Create new diagram',
        'There are no diagrams yet': 'There are no diagrams yet',
        'Are you sure you want remove the diagram': 'Are you sure you want remove the diagram',
        'If you really want to delete the diagram, type': 'If you really want to delete the diagram, type',
        'Delete diagram': 'Delete diagram',
        'diagram deleted.': 'Diagram deleted.',
        /// End RISK MANAGEMENT EDITOR - DIAGRAMS LIST

        /// RISK MANAGEMENT EDITOR - BARRIERS LIST
        'New Barrier': 'New Barrier',
        'Are you sure you want remove the barrier': 'Are you sure you want remove the barrier',
        'If you really want to delete the barrier, type': 'If you really want to delete the barrier, type',
        'Delete barrier': 'Delete barrier',
        'Load more': 'Load more',

        'barrier deleted.': 'Barrier deleted.',
        'Please insert a different name when copying barrier': 'Please insert a different name when copying barrier',
        /// End RISK MANAGEMENT EDITOR - BARRIERS LIST

        /// RISK MANAGEMENT EDITOR - BOWTIE LIST
        'New Bowtie': 'New Bowtie',
        'Create new Bowtie': 'Create new Bowtie',
        'There are no Bowties yet': 'There are no Bowties yet',
        'Are you sure you want remove the bowtie': 'Are you sure you want remove the bowtie',
        'If you really want to delete the bowtie, type': 'If you really want to delete the bowtie, type',
        'Delete bowtie': 'Delete bowtie',
        'bowtie deleted.': 'Bowtie deleted.',
        'Notified Groups': 'Notified Groups',
        /// END RISK MANAGEMENT EDITOR - BOWTIE LIST

        /// RISK MANAGEMENT EDITOR - DIAGRAM EDITOR
        'A risk diagram must have at least one threat and at least one consequence':
            'A risk diagram must have at least one consequence and at least one threat',
        'Threat must have a valid name': 'Threat must have a valid name',
        'Consequence must have a valid name': 'Consequence must have a valid name',
        'must have a valid name': 'must have a valid name',
        'Threat must have a valid initial frequency': 'Threat must have a valid initial frequency',
        'must have a valid initial frequency': 'must have a initial frequency',
        'must have a valid threshold frequency': 'must have a valid threshold frequency',
        'Top event must have a valid name': 'Top event must have a valid name',
        'Hazard must have a valid name': 'Hazard must have a valid name',
        'Value Between 0 and 1': 'Value Between 0 and 1',
        'Initial Frequency': 'Initial Frequency',
        'Final Frequency': 'Final Frequency',
        /// END RISK MANAGEMENT EDITOR - DIAGRAM EDITOR

        /// RISK MANAGEMENT EDITOR - BARRIER EDITOR
        'Please select barrier category and barrier': 'Please select barrier category and barrier',
        'Entities with errors': 'Entities with errors',
        'Barrier Update Mode': 'Barrier Update Mode',
        Method: 'Method',
        Quantitative: 'Quantitative',
        Qualitative: 'Qualitative',
        'Initial PFD': 'Initial PFD',
        'Final PFD': 'Final PFD',
        'NORMALIZATION TITLE': 'QUANTIZATION',
        'add escalation': 'add escalation',
        Deadline: 'Deadline',
        'Manual barrier is on indefinitely unless deadline is set.':
            'Manual barrier is on indefinitely unless deadline is set.',
        'Manual Barrier Status Interaction': 'Manual Barrier Status Interaction',
        'External Related Links': 'External Related Links',
        Label: 'Label',
        'Add Link': 'Add Link',
        'name (should not be equal)': 'name (should not be equal)',
        /// END RISK MANAGEMENT EDITOR - BARRIER EDITOR

        /// RISK MANAGEMENT EDITOR - BOWTIE EDITOR
        'Safety Critical Barrier (Optional)': 'Safety Critical Barrier (Optional)',
        'Bowtie Mandatory Barrier': 'Bowtie Mandatory Barrier (Pre-Operational)',
        'Threat Mandatory Barrier': 'Threat Mandatory Barrier',
        'Consequence Mandatory Barrier': 'Consequence Mandatory Barrier',
        'Once The Threat Mandatory Barrier option is selected the inactivation of it will lead to the inactivation of the whole Bowtie Web that it belongs. \nOnce The Bowtie Mandatory Barrier option is selected the inactivation of it will lead to the Top Event Occurrence directly, because it is an operational prerequisite':
            'Once The Threat Mandatory Barrier option is selected the inactivation of it will lead to the inactivation of the whole Bowtie Web that it belongs \nOnce The Bowtie Mandatory Barrier option is selected the inactivation of it will lead to the Top Event Occurrence directly, because it is an operational prerequisite',
        'Once The Consequence Mandatory Barrier option is selected the inactivation of it will lead to the Top Event Occurrence directly, because it is an operational prerequisite':
            'Once The Consequence Mandatory Barrier option is selected the inactivation of it will lead to the Top Event Occurrence directly, because it is an operational prerequisite',
        'Changes made in this interface will occur just in this Bowtie':
            'Changes made in this interface will occur just in this Bowtie',
        'barrier-removal-message': 'Are you sure you want to remove %{type} %{name} from the bowtie?',
        /// END RIS MANAGEMENT EDITOR - BOWTIE EDITOR
        // END RISK MANAGEMENT EDITOR

        /* ---------------------------------------------------------------------------------------------------------- */

        // BOWTIE VISUALIZATION
        'Degraded Barriers': 'Degraded Barriers',
        'active barriers': 'active barriers',
        'Inactive Barriers': 'Inactive Barriers',
        'Effectiveness Top': 'Effectiveness Top',
        'Effectiveness Bottom': 'Effectiveness Bottom',
        'Refers to the quantity of barriers with any degradation (including the inactive ones).':
            'Refers to the quantity of barriers with any degradation (including the inactive ones).',
        'Refers to the % of barriers that are not inactive and/or unknown status.':
            'Refers to the % of barriers that are not inactive and/or unknown status.',
        'No event': 'No event',
        // END BOWTIE VISUALIZATION

        /* ---------------------------------------------------------------------------------------------------------- */

        /* OVERVIEW */
        Intolerable: 'Intolerable',
        'degraded barriers': 'degraded barriers',
        degraded: 'degraded',
        Degraded: 'Degraded',
        Inactive: 'Inactive',
        inactive: 'inactive',
        INACTIVE: 'INACTIVE',
        active: 'active',
        MANAGER: 'MANAGER',
        Unknown: 'Unknown',
        'BOWTIES WITH DEGRADED BARRIERS': 'BOWTIES WITH DEGRADED BARRIERS',
        'Go to bowtie editor': 'Go to bowtie editor',
        Acceptable: 'Acceptable',
        Tolerable: 'Tolerable',
        Unacceptable: 'Unacceptable',
        'Invalid event': 'Invalid event',
        'inactive barriers': 'inactive barriers',
        'This is a custom client overview. It does not follow the original product standard.':
            'This is a custom client overview. It does not follow the original product standard.',
        Evidences: 'Evidences',
        /* END OVERVIEW */

        /* HELP MODAL */
        Help: 'Help',
        'Bowtie interaction': 'Bowtie interaction',
        'human barrier': 'human barrier',
        'physical barrier': 'physical barrier',
        'administrative barrier': 'administrative barrier',
        'High criticality': 'High criticality',
        'Toggle language': 'Toggle language',
        'Open help modal': 'Open help modal',
        'Highlight inactive and unknown barriers': 'Highlight inactive and unknown barriers',
        'Open first barriers level': 'Open first barriers level',
        'Close all barriers': 'Close all barriers',
        'Reset zoom and position': 'Reset zoom scale and position',
        'Zoom in': 'Zoom in',
        'Zoom out': 'Zoom out',
        'Reset zoom': 'Reset zoom',
        'Edit this bowtie': 'Edit this bowtie',
        Search: 'Search',
        Settings: 'Settings',

        /** EXPORT / IMPORT */

        /** SETTINGS */
        'Alarp Description':
            'ALARP stands for "as low as reasonably practicable" and it is directly related to Residual Risk. ALARP shows a picture of the safety level that\'s been considered at that time and it is a tolerance level definition: unacceptable, tolerable, and totally acceptable.',
        'Quantitative Description':
            'Quantitative data is used to quantify a problem by numbers. This data can be counted or compared on a numerical scale. The quantitative method contains numbers to quantify the PFD - Probability of Failure on Demand - based on the relative value of Initial PFD (above 100%).',
        'Qualitative Description':
            'Qualitative method can be defined as non-numerical data or percentual. CR - Criterion - is used to classify a percentage range in qualitative bowtie. The qualitative method output of the process is going to be a degradation status.',
        'Absolute Quantitative Description':
            'Quantitative data is used to quantify a problem by numbers. This data can be counted or compared on a numerical scale. The quantitative method contains numbers to quantify the PFD - Probability of Failure on Demand - based on the range of PFD values between 0 and 1.',
        'QUALITATIVE METHOD': 'Qualitative Method',
        'QUANTITATIVE METHOD': 'Quantitative Method',
        'NORMALIZATION METHOD':
            'This subjective value called effectiveness QLR - Qualitative Result - is quantified in PFD - Probability of Failure on Demand - from the configuration settings given by the user.',
        CATEGORY_UNMONITORED_DESCRIPTION:
            'This category corresponds to barriers that are not monitored (generally by third parties) either by sensor, by event, manually or other updating method. That is, the user does not receive any data updates in real-time.',
        ICON: 'ICON',
        CATEGORY: 'CATEGORY',
        DESCRIPTION: 'DESCRIPTION',
        AUTHOR: 'AUTHOR',
        'LAST CHANGED': 'LAST CHANGED',
        'New Category': 'New Category',
        'Delete category': 'Delete category',
        'Barrier Categories': 'Barrier Categories',
        'Alarp Levels': 'Alarp Levels',
        Color: 'Color',
        'Highest acceptable level of risk': 'Highest acceptable level of risk',
        'Generally acceptable level of risk': 'Generally acceptable level of risk',
        'Risk Rate': 'Risk Rate',
        'New Rule': 'New Rule',
        Unmonitored: 'Unmonitored',
        'Unmonitored Description':
            'PS: As an unmonitored barrier, this category does not require a status calculation. For this reason, it will not be possible to configure business rules and the fields related to PFD intervals will be disabled in the interface. They will have a unique status, which will receive the same name as the category, along with a specific color for their identification.',
        'É necessário alterar o tipo de sistema para absoluto ou relativo antes de continuar':
            'You must change the system type to absolute or relative before continuing',
        'PFD variation': 'PFD variation',
        Above: 'Above',

        /** REPORTS **/
        SETTINGS: 'SETTINGS',
        PRESETS: 'PRESETS',
        'Risk Acceptance / Risk Level': 'Risk Acceptance / Risk Level',
        'Resource Threat Status': 'Resource Threat Status',
        'Resource Consequence Status': 'Resource Consequence Status',
        'Resource Barrier Status': 'Resource Barrier Status',
        'Resource Barrier PFD': 'Resource Barrier PFD',
        'Current Mandatory Barriers': 'Current Mandatory Barrier',
        'Manual Interaction Barriers Status': 'Manual Interaction Barrier Status',
        TIMESPAN: 'TIMESPAN',
        Start: 'Start',
        End: 'End',
        to: 'to',
        resource: 'resource',
        'bowtie code': 'bowtie code',
        'bowtie name': 'bowtie name',
        'risk level status': 'risk level status',
        'date/time': 'date/time',
        'YYYY/MM/DD': 'YYYY/MM/DD',
        'threat name': 'threat name',
        'inherent risk': 'inherent risk',
        Yesterday: 'Yesterday',
        'Last day': 'Last day',
        'Last 15 days': 'Last 15 days',
        'Last week': 'Last week',
        'Last month': 'Last month',
        'Last quarter': 'Last quarter',
        'Last semester': 'Last semester',
        'Last year': 'Last year',
        Apply: 'Apply',
        Clear: 'Clear',
        page: 'page',
        'All time': 'All time',
        'Select a preset and a time range to view a report': 'Select a preset and a timespan to view a report',
        'initial frequency': 'initial frequency',
        'final frequency': 'final frequency',
        'barrier id': 'barrier id',
        'barrier name': 'barrier name',
        'safety critical': 'safety critical',
        responsible: 'responsible',
        'Selected filters': 'Selected filters',
        'Clear  all': 'Clear  all',
        category: 'category',
        'entity name': 'entity name',
        'initial pfd': 'initial pfd',
        'final pfd': 'final pfd',
        threshold: 'threshold',
        'Threshold Frequency': 'Threshold Frequency',
        'PFD max': 'PFD max',
        'Lowly degraded': 'L.Degraded',
        LOW_DEGRADED: 'L.DEGRADED',
        HIGHLY_DEGRADED: 'H.DEGRADED',
        UNMONITORED: 'UNMONITORED',
        HIGH_DEGRADED: 'H.DEGRADED',
        'Highly degraded': 'H.Degraded',
        unmonitored: 'não monitorada',
        'Resource Barrier Analysis': 'Resource Barrier Analysis',
        'time interval': 'time interval',
        'time gathered': 'time gathered',
        'Select an item from the list to view the graphic': 'Select an item from the list to view the graphic',
        Graphic: 'Graphic',
        END: 'END',
        START: 'START',
        'Time Interval': 'Time interval',
        'Clear all filter view': 'Clear all filter view',
        'Filters removed successfully.': 'Filters removed successfully.',
        'consequence name': 'consequence name',
        'threshold frequency': 'threshold frequency',
        'There is no data for the specified period.': 'There is no data for the specified period.',
        /** END */
        'Barrier Status Nomenclature Change': 'Barrier Status Nomenclature Change',
        'The system allows you to change the default nomenclature used for barrier status. Default colors cannot be changed.':
            'The system allows you to change the default nomenclature used for barrier status. Default colors cannot be changed.',
        'WARNING: ': 'WARNING: ',
        'Changes on the default nomenclature will affect all barriers in the system.':
            'Changes on the default nomenclature will affect all barriers in the system.',
        'Default nomenclature': 'Default nomenclature',
        'New nomenclature': 'New nomenclature',
        /** end of BarrierStatusCustomName */

        /* ALARMS */
        WELCOME: 'WELCOME',
        'Here you can create groups, edit groups and add groups to bowties.':
            'Here you can create groups, edit groups and add groups to bowties.',
        'New Group': 'New Group',
        'Alarms Configurations': 'Alarms Configurations',
        'Group Edition': 'Group Edition',
        EDITION: 'EDITION',
        Group: 'Group',
        '4Group': 'Group',
        GROUP: 'GROUP',
        Users: 'Users',
        USERS: 'USUÁRIOS',
        RESPONSIBLE: 'RESPONSIBLE',
        Subscriptions: 'Subscriptions',
        'Save group without users': 'Save group without users',
        'Are you sure you want save this group without any associated users?':
            'Are you sure you want save this group without any associated users?',
        'You can add users editing this group later.': 'You can add users editing this group later.',
        Confirm: 'Confirm',
        'Are you sure you want remove the alarm group': 'Are you sure you want remove the alarm group',
        'Here you can customize your subscriptions, notifications and reports.':
            'Here you can customize your subscriptions, notifications and reports.',
        'Every option you subscribe to will reflect on all notification settings.':
            'Every option you subscribe to will reflect on all notification settings.',
        'Email Notifications': 'Email Notifications',
        'If you choose to receive email notifications, all the items you subscribed will be send by email in addition to system notifications.':
            'If you choose to receive email notifications, all the items you subscribed will be send by email in addition to system notifications.',
        'Sounds Notifications': 'Sounds Notifications',
        'If you choose to receive sound notifications, all the items you subscribed will be send by sound in addition to system notifications.':
            'If you choose to receive sound notifications, all the items you subscribed will be send by sound in addition to system notifications.',
        'Receive email notifications': 'Receive email notifications',
        'Receive sounds notifications': 'Receive sounds notifications',
        'Send Test email': 'Send Test email',
        'Send Test sound': 'Send Test sound',
        'unseen alarms': 'unseen alarms',
        'There are': 'There are',
        'detected alarms': 'detected alarms',
        'Filter Operation and Filter Severity': 'Filter Operation and Filter Severity',
        'Go to Alarms': 'Go to Alarms',
        'Selected Filters: ': 'Selected Filters: ',
        'Clear all': 'Clear all',
        'had a ': 'had a ',
        'FATAL event detected': 'CRITICAL event detected',
        'Last triggered': 'Last triggered',
        'Diagram view': 'Diagram view',
        'Alert on': 'Alert on',
        Acknowledge: 'Acknowledge',
        'Save acknowledge': 'Save acknowledge',
        'BOWTIE CONTEXT:': 'BOWTIE CONTEXT:',
        'Trigger Log': 'Trigger Log',
        'triggers in the last month': 'triggers in the last month',
        'ALERTS BY DAY': 'ALERTS BY DAY',
        'Last 30 days': 'Last 30 days',
        'triggered on the last 7 days': 'triggered on the last 7 days',
        'triggers in the last month single': 'triggers in the last month',
        'had an ': 'had an ',
        TOP_EVENT: 'TOP EVENT',
        'Select an alarm to see its details.': 'Select an alarm to see its details.',
        'Info Alerts': 'Info Alerts',
        'Warn Alerts': 'Warn Alerts',
        'Error Alerts': 'Error Alerts',
        'Fatal Alerts': 'Critical Alerts',
        'You need select a bowtie to configure a group.': 'You need select a bowtie to configure a group.',
        'Please, input a name for alarm group.': 'Please, input a name for alarm group.',
        'Please, input a description for alarm group.': 'Please, input a description for alarm group.',
        yourf: 'your',
        yourm: 'your',
        fatal: 'critical',
        FATAL: 'CRITICAL',
        name: 'name',
        DeleteAlarm: 'Delete',
        'barrier category': 'barrier category',
        supervisor: 'supervisor',
        'Manual Interaction Initial PFD': 'Manual Interaction Initial PFD',
        'Manual Interaction Initial Fequency': 'Manual Interaction Initial Fequency',
        'Manual Interaction Final PFD': 'Manual Interaction Final PFD',
        'Manual Interaction MOC': 'Manual Interaction MOC',
        'Manual Interaction Responsible': 'Manual Interaction Responsible',
        'update mode code': 'update mode code',
        'at least one barrier': 'at least one barrier',
        High: 'High',
        Low: 'Low',
        Required: 'Required',
        'Value Between 0 and 100': 'Value Between 0 and 100',
        'false alarm': 'False alarm',
        'true alarm': 'True alarm',
        'missing alarm': 'Missing alarm',
        'dismiss alarm': 'Dismiss alarm'
    }
}
